export interface AdminPagesEditorConfig {
  profilePreviewUrl: string;
  publicSiteUrl: string;
  /** Origin of the beta website used as an alternative preview target. */
  betaSiteUrl: string;
}

const defaultProfilePreviewUrl =
  typeof import.meta !== "undefined" && import.meta.env?.DEV
    ? "http://localhost:3000/freelancer-preview"
    : "https://shopexperts.com/freelancer-preview";

const config: AdminPagesEditorConfig = {
  profilePreviewUrl: defaultProfilePreviewUrl,
  publicSiteUrl: typeof import.meta !== "undefined" && import.meta.env?.DEV
    ? "http://localhost:3000"
    : "https://shopexperts.com",
  betaSiteUrl: "https://beta.shopexperts.com",
};

export function configureAdminPagesEditor(options: Partial<AdminPagesEditorConfig>) {
  if (options.profilePreviewUrl) {
    config.profilePreviewUrl = options.profilePreviewUrl;
  }
  if (options.publicSiteUrl) {
    config.publicSiteUrl = options.publicSiteUrl;
  }
  if (options.betaSiteUrl) {
    config.betaSiteUrl = options.betaSiteUrl;
  }
}

export function getAdminPagesEditorConfig(): AdminPagesEditorConfig {
  return config;
}
